import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { TreasurehuntService } from 'src/app/services/treasureHunt/treasurehunt.service';

@Component({
    selector: 'app-view-team',
    templateUrl: './view-team.page.html',
    styleUrls: ['./view-team.page.scss'],
    standalone: false
})
export class ViewTeamPage extends BaseInjectorService implements OnInit {

  selectedType : any;
  appData: any;
  @Input() team: any;
  @Input() activate : boolean;
  @Input() viewInactiveMembers :boolean;
  @Input() cancelMyRequest  :boolean;
  @Input() userMail : any;

  teamMembers : any = [];
  

  constructor(
    public treasurehuntService:TreasurehuntService,
    private modalCtrl:ModalController) {
      super();
     }

  ngOnInit() {
    
  }


  async ionViewDidEnter()
  { 
    this.appData = await this.lhStorage.get("appData");
    this.selectedType = this.treasurehuntService.TreasureHuntinfo['selected-hunt']; 
    let docInfo = await this.lhFire.queryCollection(`team_registration/${this.team.id}/members`);
      docInfo.forEach((doc:any) =>{
        this.teamMembers.push(doc.data());
      })
  }

  closePopup()
  {    
    this.modalCtrl.dismiss();
  }

  cancelRequest(){
    let header =  this.translate.instant("TREASURE_HUNT.DEACTIVATE_TEAM_CONFIRM");
    let message = this.translate.instant("TREASURE_HUNT-TEAM-EXIT-MYSELFT-FROM-TEAM")
    this.confirmAlert(header,message);
  }


  async confirmAlert(header,message) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message:  message,
      buttons: [
        {
          text: this.translate.instant('ADD_QR.BTN_CANCEL'),
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => {
          }
        }, {
          text: this.translate.instant('APP_OK'),
          id: 'confirm-button',
          handler: () => {
            this.removeMember()
          }
        }
      ]
    });
    await alert.present();
  }


    async removeMember(){
      await this.overlayService.presentLoading(this.createLoaderOptions(this.translate.instant('APP_LOADING')));
      await this.lhFire.delete(`team_registration/${this.team.id}/members`,this.userMail);
      await this.overlayService.dismissLoading();
      this.closePopup(); 
    }



  async joinSelectedTeam(){
    if(this.teamMembers.length < 4){
      await this.overlayService.presentLoading(this.createLoaderOptions(this.translate.instant('APP_LOADING')));
      let currentUser : any = this.appData.userInfo;
      const getNotificationsByUserCallable = this.apiService.httpsCallable('sendTreasureHuntRequestForJoining');
      getNotificationsByUserCallable({
        "team_id": this.team.id,
        "from_email": currentUser.email,
        "team_lead_email" : this.team.email,
        "team_name": this.team.team_name,
        "from_name": currentUser.Fname,
        "hunt_type": this.team.huntType
      }).subscribe(async response => {
        if (response.status) {
          await this.overlayService.dismissLoading();
          this.overlayService.presentToast(this.createToastOptions(this.translate.instant('TREASURE_HUNT.REQUEST_SENT')));
        }
      });
    

      currentUser.user_name = currentUser['Fname'] + " "+currentUser['Lname'];
      currentUser.treasure_hunt_id=this.team.treasure_hunt_id;
      currentUser.active = false;
      currentUser.isBogUser = true;
      currentUser.team_id=this.team.id;
      currentUser.isTeamLead=false;
      currentUser.sendEmail=true;
      currentUser.start_date= this.moment(new Date()).format('YYYY-MM-DD');;

      await this.lhFire.addData(`team_registration/${this.team.id}/members`,currentUser);
      await this.overlayService.dismissLoading();
      this.overlayService.presentToast(this.createToastOptions(this.translate.instant('TREASURE_HUNT.REQUEST_SENT')));


      this.closePopup();
    }else{
      this.overlayService.presentToast(this.createToastOptions(this.translate.instant('TREASURE_HUNT.TEAM-SIZE-FULL')));
    }
  
  }

  async activateSelectedTeam(){
    this.confirmAlertActivateTeam();
  }



  async confirmAlertActivateTeam() {
    console.log(this.team);
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.translate.instant("TREASURE_HUNT.DEACTIVATE_TEAM_CONFIRM"),
      message: "Are you sure you want to activate team "+this.team.team_name,
      buttons: [
        {
          text: this.translate.instant("ADD_QR.BTN_CANCEL"),
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: this.translate.instant("APP_OK"),
          id: 'confirm-button',
          handler: () => {
            this.activateTeam();
          }
        }
      ]
    });

    await alert.present();
  }

 async activateTeam(){
    this.treasurehuntService.TreasureHuntinfo['hunt_team'] = this.team;
    this.treasurehuntService.TreasureHuntinfo['selectedTeamMembers'] =this.teamMembers;
    await this.overlayService.presentLoading(this.createLoaderOptions(this.translate.instant('APP_LOADING')));
    await this.lhFire.update(`team_registration`,this.team.id,{active :true}); 
    await this.overlayService.dismissLoading();
    this.treasurehuntService.TreasureHuntinfo['createFlag']=false;
    await this.lhStorage.set('treasureHunt',this.treasurehuntService.TreasureHuntinfo);
    this.overlayService.presentToast(this.createToastOptions(this.translate.instant("Team activated successfully")));
    this.modalCtrl.dismiss('added');
  }
}
